import { makeHook } from "../../utils/makeSingleArgHook";
import { listSubjectsWithRelation, url, } from "../requests/getListSubjectsWithRelation";
export const ListSubjectsWithRelationMasterCacheKey = "listSubjectsWithRelation";
// As we need to be able to recursively invalidate the cache, we need to customize this key maker
export function listSubjectsWithRelationKeyMaker(queryParams) {
    return [
        ListSubjectsWithRelationMasterCacheKey, // This is the key that will invalidate the entire cache
        queryParams.resourceType,
        queryParams.resourceId,
        queryParams.relation,
        queryParams.subjectType,
        url(queryParams),
    ];
}
const useListSubjectsWithRelation = makeHook(async (params, config) => listSubjectsWithRelation(params, config), listSubjectsWithRelationKeyMaker);
export default useListSubjectsWithRelation;
//# sourceMappingURL=useListSubjectsWithRelation.js.map